const getDamaVariations = (commonCanopies, commonVariaton) => {

	return {
		'3235': {
			...commonVariaton,
			size: {
				width: 0.45,
				height: 0.25,
				depth: 0.45
			},
			paddingTop: -0.35,
			familyName: 'flat',
			related: ['3235'],
			canopy: {
				...commonCanopies,
				"10": {
					...commonCanopies['10'],
					source: '/models/canopy_skan.glb',
					size: {
						width: 0.16,
						depth: 0.16,
						height: 0.033
					},
				}
			},
			light: {
				type: 'spot',
				power: 199,
				options: { angle: Math.PI / 8 }
			}
		}
	}
}

export default getDamaVariations